import { Check } from 'lucide-react';
import { useWizard } from './WizardContext';
import { cn } from '@/lib/utils';

export const ProgressIndicator = () => {
  const { currentStep, totalQuestions } = useWizard();

  // Don't show on intro (step 0) or results (step > totalQuestions)
  if (currentStep === 0 || currentStep > totalQuestions) {
    return null;
  }

  return (
    <div className="w-full">
      {/* Step counter text */}
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm font-medium text-muted-foreground">
          Step {currentStep} of {totalQuestions}
        </span>
        <span className="text-sm text-muted-foreground">
          {Math.round((currentStep / totalQuestions) * 100)}% complete
        </span>
      </div>

      {/* Progress bar */}
      <div className="relative h-1.5 bg-muted rounded-full overflow-hidden">
        <div 
          className="absolute inset-y-0 left-0 bg-primary rounded-full transition-all duration-300 ease-out"
          style={{ width: `${(currentStep / totalQuestions) * 100}%` }}
        />
      </div>

      {/* Step indicators */}
      <div className="flex items-center justify-between mt-4">
        {Array.from({ length: totalQuestions }, (_, i) => {
          const stepNumber = i + 1;
          const isCompleted = currentStep > stepNumber;
          const isActive = currentStep === stepNumber;
          const isPending = currentStep < stepNumber;

          return (
            <div key={stepNumber} className="flex flex-col items-center">
              <div
                className={cn(
                  'w-8 h-8 rounded-full flex items-center justify-center text-xs font-medium transition-all duration-200',
                  isCompleted && 'bg-primary text-primary-foreground',
                  isActive && 'bg-primary text-primary-foreground ring-2 ring-primary ring-offset-2 ring-offset-background',
                  isPending && 'bg-muted text-muted-foreground'
                )}
              >
                {isCompleted ? (
                  <Check className="w-4 h-4" />
                ) : (
                  stepNumber
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
